import { render, staticRenderFns } from "./DsioMore.vue?vue&type=template&id=61f136aa&"
import script from "./DsioMore.vue?vue&type=script&lang=js&"
export * from "./DsioMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f136aa')) {
      api.createRecord('61f136aa', component.options)
    } else {
      api.reload('61f136aa', component.options)
    }
    module.hot.accept("./DsioMore.vue?vue&type=template&id=61f136aa&", function () {
      api.rerender('61f136aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioMore.vue"
export default component.exports